import "./CollectionPopUp.css";

import { memo, useEffect, useRef } from "react";

import { Divider } from "@mui/material";
import { PopUpHeader } from "./PopUpHeader";
import { PopUpItem } from "./PopUpItem";
import { Popup } from "react-mapbox-gl";
import { View } from "../../View";
import { makeStyles } from "@mui/styles";
import { orderBy } from "lodash";
import { palette } from "../../../theme/palette";
import { selectedCollectionSelector } from "../../../reducers/matrixProfile/selectors";
import { useSelector } from "react-redux";

const useStyles = makeStyles({
  popup: {
    borderColor: palette.typography.black.high,
    borderRadius: "6px",
    padding: 0,
  },
  container: {
    width: "220px",
    padding: "10px",
    backgroundColor: palette.typography.black.high,
    color: palette.typography.white.high,
    borderRadius: "5px",
  },
  divider: {
    marginTop: "10px",
    marginBottom: "10px",
    backgroundColor: palette.typography.white.high,
  },
  itemContainer: {
    maxHeight: "200px",
    overflow: "auto",
    marginRight: "-14px",
  },
});

export const CollectionPopUp = memo(() => {
  const styles = useStyles();
  const collections = useSelector(selectedCollectionSelector);
  const ref = useRef(null);

  useEffect(() => {
    if (collections && ref) {
      ref.current.scrollIntoView();
    }
  }, [collections]);

  return (
    <Popup
      coordinates={collections[0].stopLocation.coordinates}
      anchor={"bottom"}
      offset={45}
      className={styles.popup}
    >
      <View className={styles.container}>
        <PopUpHeader />
        <View className={styles.itemContainer}>
          <div ref={ref} />
          {orderBy(collections, ["routeCode", "scheduledTime"]).map(
            (collection, index) => (
              <View key={index}>
                <PopUpItem collection={collection} />
                {index < collections.length - 1 && (
                  <Divider className={styles.divider} />
                )}
              </View>
            )
          )}
        </View>
      </View>
    </Popup>
  );
});
